// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"b0aae270","143":"9a12fba3","186":"31fe6df2","381":"fb72e7e3","494":"521f7270","533":"f080a1ab","682":"2fcd6231","852":"cd65d647","940":"968dff1e"}[chunkId] + ".chunk.js";
};